import { paragraphs } from "../lib/content";

/** Renders CMS multiline text as paragraphs (blank line = new paragraph). */
export function CmsText({ text, className }: { text: string; className?: string }) {
  return (
    <>
      {paragraphs(text).map((p, i) => (
        <p key={i} className={className}>
          {p}
        </p>
      ))}
    </>
  );
}
